import { oz } from '@weft/utils';

export const NetSuiteCertSecretsSchema = oz.object({
  PRIVATE_KEY: oz.string(),
  SIGNATURE_ALGORITHM: oz.string(),
});

export type NetSuiteCertSecrets = oz.infer<typeof NetSuiteCertSecretsSchema>;